import React, { useState } from 'react';
import Draggable from 'react-draggable';
import PropTypes from 'prop-types';

const minColumnWidth = 100;
const defaultColumnWidth = 150;

function mapInitialPropsToColumns(headerRow) {
    const { columns } = headerRow.reduce(
        (accumulator, column) => {
            const width =
                column.width === 0 || column.width < minColumnWidth
                    ? defaultColumnWidth
                    : column.width;

            const xOffset = width + accumulator.totalWidth;

            return {
                totalWidth: xOffset,
                columns: [
                    ...accumulator.columns,
                    {
                        ...column,
                        width,
                        position: xOffset,
                    },
                ],
            };
        },
        { totalWidth: 0, columns: [] }
    );

    return columns;
}

export default function DraggableHeader(props) {
    const [columns, setColumns] = useState(
        mapInitialPropsToColumns(props.columns)
    );

    function resizeColumn(dataKey, deltaX) {
        const foundColumn = columns.find(
            (column) => column.dataKey === dataKey
        );

        if (foundColumn.width + deltaX <= defaultColumnWidth) {
            return;
        }

        setColumns((prevColumns) => {
            const indexOfColumn = prevColumns.findIndex(
                (column) => column.dataKey === dataKey
            );

            return prevColumns.map((column, index) => {
                if (index < indexOfColumn) {
                    return column;
                }

                if (index === indexOfColumn) {
                    return {
                        ...column,
                        width: column.width + deltaX,
                    };
                }

                return {
                    ...column,
                    position: column.position + deltaX,
                };
            });
        });
    }

    function getColumnWidth(dataKey) {
        return columns.find((column) => column.dataKey === dataKey)?.width ?? 0;
    }

    function getPosition(dataKey) {
        const foundColumn = columns.find(
            (column) => column.dataKey === dataKey
        );

        return foundColumn ? { x: foundColumn.position } : { x: 0 };
    }

    function renderDraggableIcon(dataKey) {
        return (
            <Draggable
                axis="x"
                defaultClassName="DragHandle"
                defaultClassNameDragging="DragHandleActive"
                onDrag={(event, { deltaX }) => {
                    event.stopPropagation();
                    resizeColumn(dataKey, deltaX);
                }}
                position={getPosition(dataKey)}
                zIndex={999}
            >
                <span className="DragHandleIcon" />
            </Draggable>
        );
    }

    return props.children({ renderDraggableIcon, getColumnWidth });
}
DraggableHeader.propTypes = {
    children: PropTypes.func.isRequired,
    columns: PropTypes.instanceOf(Array).isRequired,
};
